import { Ajaxinate } from 'ajaxinate'; // Used on Collections for Infinite Scroll & Load More

// Note:  This function is overriding the version in the npm package, because
//        that version breaks in the Theme editor.
//        Github issue reference: https://github.com/Elkfox/Ajaxinate/issues/26
Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    var parser = new DOMParser();
    var htmlDoc = parser.parseFromString(this.request.responseText, "text/html");
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = htmlDoc.querySelectorAll(this.settings.container)[0];
      var newPagination = htmlDoc.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.overrideMimeType("text/html");
  this.request.send();
};

import Section from '../Section';
import Parallax from '../global/Parallax';
import Vue from 'vue';
import Dropdown from '../components/Dropdown.vue';
import QuickAdd from '../global/QuickAdd';

export default class Collection extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.pageLoad = pageLoad;

    this.init();

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', this.init);
    }

    // Initialise Sort by Vue component
    /** Array of initialized vue components
   * @type {Array<Object>}
   */
    this.vueComponents = [];
    const tagName = 'wetheme-dropdown';
    const VueComponent = Dropdown;
    const gridElement = document.querySelector(`[data-wetheme-section-type=template--collection]`);

    this.loadQuickAdd();
    this.loadVueComponent(element, tagName, VueComponent);
    this.loadTagFilter();
    this.mobileSidebar();
    this.loadPaging();
    document.addEventListener('paginate', this.loadPaging);
  }

  init = () => {
    this.initParallax();
  }

  initParallax = () => {
    const parallaxEl = document.querySelector('.parallax');

    if (!parallaxEl) return;
    this.parallax = new Parallax(this.theme, parallaxEl);
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }

  /**
  * Load all instances of one vue component
  *
  * @param {HTMLElement} element Element which children should be search for vue components
  * @param {string} tagName
  * @param {*} Component
  */
  loadVueComponent = (element, tagName, Component) => {
    Array.prototype.forEach.call(
      document.querySelectorAll(`.js-collection-sort-by ${tagName}`),
      (el) => {
        const attr = {
          theme: this,
        };
        if (el.hasAttributes()) {
          var attrs = el.attributes;
          for (let i = attrs.length - 1; i >= 0; i--) {
            const { name, value } = attrs[i];
            if (value === 'true') {
              attr[name] = true;
            } else if (value === 'false') {
              attr[name] = false;
            } else {
              attr[name] = value;
            }
          }
        }
        const c = new Vue({
          el: el,
          render: (h) => {
            return h(Component, { attrs: attr });
          },
        });
        this.vueComponents.push(c);
      }
    );
  }

  loadPaging = () => {
    const isInfinite = document.getElementById('AjaxinateInfiniteScrolling');
    if (isInfinite) {
      new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinateInfiniteScrolling',
        method: 'scroll',
        loadingText: 'Loading',
        offset: 500
      });
      return;
    }

    const isLoadMore = document.getElementById('AjaxinateLoadMore');
    if (isLoadMore) {
      new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinateLoadMore',
        method: 'click',
        loadingText: 'Loading'
      });
      return;
    }
  };

  loadTagFilter = () => {
    // Product Tag Filters - Good for any number of filters on any
    // type of collection pages
    const collFilters = document.querySelectorAll('.coll-filter');

    collFilters.forEach((collFilter) => {
      collFilter.addEventListener('change', (event) => {
        let newTags = [];

        collFilters.forEach((
          /** @type {HTMLSelectElement} */ currentFilter
        ) => {
          const val = currentFilter.value;

          if (val) {
            newTags.push(val);
          }

          if (newTags.length) {
            const query = newTags.join('+');
            const genericLink = /** @type {HTMLLinkElement} */ (document.querySelector(
              '#link-to-tag-generic a'
            ));
            const href = genericLink.href;

            window.location.href = href.replace(
              /\/tag($|\?)/,
              '/' + query + '$1'
            );
          } else {
            const linkToCollection = /** @type {HTMLInputElement} */ (document.getElementById(
              'link-to-collection'
            ));
            window.location.href = linkToCollection.value.toString();
          }
        });
      });
    });
  };

  mobileSidebar = () => {
    const mobileSidebarHeadings = document.querySelectorAll(
      '.collection-sidebar--section h2'
    );

    mobileSidebarHeadings.forEach((mobileSidebarHeading) => {
      mobileSidebarHeading.addEventListener('click', (event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        target.parentElement.classList.toggle('expanded');
      });
    });
  };
}
